import axios from "axios";

const state = {
    adjustments: null,
    loading: false,
    error: null
};

const mutations = {
    SET_ADJUSTMENTS(state, adjustments) {
        state.adjustments = adjustments;
    },
    SET_LOADING(state, status) {
        state.loading = status;
    },
    SET_ERROR(state, error) {
        state.error = error;
    }
};

const actions = {
    async fetchFontAdjustments({ commit }) {
        commit("SET_LOADING", true);
        try {
            // Try to load from localStorage first for development convenience
            const cachedAdjustments = localStorage.getItem("fontAdjustments");
            if (cachedAdjustments) {
                commit("SET_ADJUSTMENTS", JSON.parse(cachedAdjustments));
            }

            // Then fetch from API to get latest
            const { data } = await axios.get("/web-api/font-adjustments");
            commit("SET_ADJUSTMENTS", data);
            localStorage.setItem("fontAdjustments", JSON.stringify(data));

            return data;
        } catch (error) {
            commit("SET_ERROR", error);
            console.error("Failed to load font adjustments:", error);
        } finally {
            commit("SET_LOADING", false);
        }
    },

    async updateFontAdjustments({ commit }, adjustments) {
        commit("SET_LOADING", true);
        try {
            await axios.post("/web-api/font-adjustments", adjustments);
            commit("SET_ADJUSTMENTS", adjustments);
            localStorage.setItem(
                "fontAdjustments",
                JSON.stringify(adjustments)
            );

            // Clear any cache in CalendarUtils
            import("@/utils/calendar").then((module) => {
                module.default.clearDescriptionLinesCache();
            });

            return adjustments;
        } catch (error) {
            commit("SET_ERROR", error);
            console.error("Failed to update font adjustments:", error);
        } finally {
            commit("SET_LOADING", false);
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
